/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

/**
 * Common sitemap content types used by both Next.js apps and Cloudflare Workers.
 *
 * This file is intentionally kept separate from sitemap.utils.ts to avoid importing
 * @cosmos/hygraph-data which uses process.env at module load time
 * (incompatible with Cloudflare Workers runtime).
 */
export const commonSitemapContentTypes = [
	"cosmosPageAgreements",
	"cosmosPageBlogDetails",
	"cosmosPageEulaKeys",
	"cosmosPageFeeds",
	"cosmosPageHeroAndSections",
	"cosmosPageLegalContents",
	"cosmosPageLicenses",
	"cosmosPageSearches",
	"cosmosPageResearches",
	"cosmosPagePluginDetails",
	"cosmosPageDirectories",
];

/**
 * Content types that support owner filtering via the `owner` relation field.
 * Add new content types here as they gain owner support in Hygraph.
 */
export const ownerFilterableContentTypes = new Set([
	"cosmosPageHeroAndSections",
	"cosmosPageBlogDetails",
	"cosmosPageEulaKeys",
	"cosmosPageLegalContents",
	"kwsPageForms",
	"cosmosPageDirectories",
]);

/**
 * Content types that are intrinsically scoped to a single site even though they
 * do not model an `owner` relation. When a non-default-owner sitemap declares
 * one of these via `sitemapContentTypes`, the sitemap fetcher includes ALL
 * records (no owner filter) instead of skipping the type.
 *
 * Example: `eacPageForms` lives in the EOS Hygraph project but is only
 * referenced by the EAC site's appeal/contact form pages. EAC declares it in
 * its `sitemapContentTypes`; the OS site does not. Without this bypass, the
 * skip-when-no-owner-support logic would drop EacPageForm records from the
 * EAC sitemap.
 */
export const siteScopedContentTypes = new Set(["eacPageForms"]);
